const prefix = '/api/v2/agent'

export const name = 'official-account-api-config'

export const api = {
  weChat: {
    batchCollection: `${prefix}/purchaser/we-chat/ticket/discernBatch`, // post 批量采集
    saveCollections: `${prefix}/purchaser/we-chat/vat/saveBatch`, // 批量或单独保存发票采集
    freeAccountLogin: `${prefix}/purchaser/account/login/free`, // get
    discern: `${prefix}/purchaser/we-chat/ticket/discern`, // post
    sendCode: `${prefix}/purchaser/account/login/code/send`, // get
    checkAuthCode: `${prefix}/purchaser/account/login/code/check`, // get
    listAccountbyMobile: `${prefix}/purchaser/account-list/mobile`, // post query
    getInvoiceList: `${prefix}/purchaser/we-chat/ticket/page`, // get
    nonVatSaveAndCommit: `${prefix}/purchaser/we-chat/non-vat/save-commit`, // post
    nonVatSave: `${prefix}/purchaser/we-chat/non-vat/save`, // post
    newNonVatSave: `${prefix}/purchaser/huiSui/non-vat/save`, //
    vatSaveAndCommit: `${prefix}/purchaser/we-chat/vat/save-commit`, // post
    vatSave: `${prefix}/purchaser/we-chat/vat/save`, // post
    newVatSave: `${prefix}/purchaser/mobile/vat/save`, //
    nonVatUpdate: `${prefix}/purchaser/we-chat/non-vat/edit`, // put
    nonVatCommit: `${prefix}/purchaser/we-chat/non-vat/commit`, // put
    nonVatEditAndCommit: `${prefix}/purchaser/we-chat/non-vat/edit-commit`, // put
    nonVatDel: `${prefix}/purchaser/we-chat/non-vat/delete/:id`, // delete :id
    vatUpdate: `${prefix}/purchaser/we-chat/vat/edit`, // put
    vatUpdateAndCommit: `${prefix}/purchaser/we-chat/vat/edit-commit`, // put
    vatCommit: `${prefix}/purchaser/we-chat/vat/commit`, // put
    vatEditAndCommit: `${prefix}/purchaser/we-chat/vat/edit-commit`, // put
    vatDel: `${prefix}/purchaser/we-chat/vat/delete/:id`, // delete :id
    getNonVat: `${prefix}/purchaser/we-chat/non-vat/:id`, // get :id
    getVat: `${prefix}/purchaser/we-chat/vat/:id`, // get :id
    vatCheck: `${prefix}/purchaser/we-chat/vat/check/:id`, // put
    getOffiaccountSignature: `${prefix}/purchaser/account/signature/get`, // get
    batchCommit: `${prefix}/purchaser/we-chat/batch-commit`, // post 批量报账
    getTicketStatistics: `${prefix}/purchaser/we-chat/ticket-statistics`, // post 获取进项统计数据
    editInvoice: `${prefix}/purchaser/invoice/update/item`, // 增值税保存
    editNoInvoice: `${prefix}/purchaser/discern/multiple/saveGatherToTicket`, // 非曾保存
    againInspection: `${prefix}/purchaser/huiSui/invoice/discern/check`, // 重新查验
    checkRepeat: `${prefix}/purchaser/we-chat/vat/saveBatchMobileCheck` // Post校验是否重复发票
  }
}
